module.exports = __webpack_public_path__ + "img/feature-cafeteria-videowall-menu.b4bd71bc.webp";